import { DashboardConfig } from '../../common/components/dashboards/types';
import { AlexDashboardChartConfig } from './alex_dashboard_config';
import { CreaturesDashboardChartConfig } from './creatures_dashboard_config';
import { JTBDashboardChartConfig } from './jtb_dashboard_config';
import { MixiHumanCapitalDashboardConfig } from './mixi/human-capital/human-capital-dashboard_config';
import { NikkiGlobalHrAsDashboardConfig } from './nikki/global-hr-as/nikki-global-hr-as-dashboard-config';
import { NikkiHeadcountDashboardConfig } from './nikki/headcount/nikki_headcount_dashboard_config';
import { NikkiLeaversDashboardConfig } from './nikki/leavers/nikki_leavers_dashboard_config';
import { NikkiTurnoverDashboardConfig } from './nikki/turnover/nikki_turnover_dashboard_config';
import { PatagoniaHumanResourcesDashboardConfig } from './patagonia/patagonia_human_resources/patagonia_human_resources_dashboard.config';
import { ShaqDashboardChartConfig } from './shaq_dashboard_config';
import { ShipHealthcareDashboardChartConfig } from './shiphealthcare_dashboard_config';
import { ShipHealthcareDashboardChartConfig2 } from './shiphealthcare_dashboard_config_2';
import { ValentinDashboardChartConfig } from './valentin_dashboard_chart_config';
import { WashiHumanCapitalManagementDashboardConfig } from './washi/human-capital/human-capital-management-dashboard_config';

export const defaultDashboardConfigs: DashboardConfig[] = [];
export const jtDashboardConfigs: DashboardConfig[] = [];
export const shipHealthcareDashboardConfigs: DashboardConfig[] = [
  ShipHealthcareDashboardChartConfig,
  ShipHealthcareDashboardChartConfig2,
];
export const swanDashboardConfigs: DashboardConfig[] = [
  AlexDashboardChartConfig,
  ShaqDashboardChartConfig,
];
export const allDashboardConfigs: DashboardConfig[] = [
  AlexDashboardChartConfig,
  ShaqDashboardChartConfig,
  ValentinDashboardChartConfig,
  JTBDashboardChartConfig,
];

export const jtbDashboardConfigs: DashboardConfig[] = [JTBDashboardChartConfig];

export const creaturesDashboardConfigs: DashboardConfig[] = [
  CreaturesDashboardChartConfig,
];
export const nikkiDashboardConfigs: DashboardConfig[] = [
  NikkiHeadcountDashboardConfig,
  NikkiTurnoverDashboardConfig,
  NikkiLeaversDashboardConfig,
  NikkiGlobalHrAsDashboardConfig,
];

export const mixiDashboardConfigs: DashboardConfig[] = [
  MixiHumanCapitalDashboardConfig,
];
export const washiDashboardConfigs: DashboardConfig[] = [
  WashiHumanCapitalManagementDashboardConfig,
];

export const patagoniaDashboardConfigs: DashboardConfig[] = [
  PatagoniaHumanResourcesDashboardConfig,
];
